<template>
<div class="projectheatmapconfig">
  <el-card shadow="never">{{ projectName }}</el-card>
  <el-card shadow="never">
    <template>
      <el-radio-group v-model="radio">
        <el-radio label="1">
          <span>磷酸铁锂</span>
          <div class="tableClass">
            <el-table class="vTable" :data="vTableData1" :cell-style="cellStyle">
              <el-table-column label="电压" align="center">
                <el-table-column prop="startValue" label="起始值" align="center">
                </el-table-column>
                <el-table-column prop="endValue" label="结束值" align="center">
                </el-table-column>
                <el-table-column prop="color" label="颜色" align="center">
                </el-table-column>
              </el-table-column>
            </el-table>
            <el-table class="tTable" :data="tTableData1" :cell-style="cellStyle">
              <el-table-column label="温度" align="center">
                <el-table-column prop="startValue" label="起始值" align="center">
                </el-table-column>
                <el-table-column prop="endValue" label="结束值" align="center">
                </el-table-column>
                <el-table-column prop="color" label="颜色" align="center">
                </el-table-column>
              </el-table-column>
            </el-table>
          </div>
        </el-radio>
        <el-radio label="2">
          <span>三元锂</span>
          <div class="tableClass">
            <el-table class="vTable" :data="vTableData2" :cell-style="cellStyle">
              <el-table-column label="电压" align="center">
                <el-table-column prop="startValue" label="起始值" align="center">
                </el-table-column>
                <el-table-column prop="endValue" label="结束值" align="center">
                </el-table-column>
                <el-table-column prop="color" label="颜色" align="center">
                </el-table-column>
              </el-table-column>
            </el-table>
            <el-table class="tTable" :data="tTableData2" :cell-style="cellStyle">
              <el-table-column label="温度" align="center">
                <el-table-column prop="startValue" label="起始值" align="center">
                </el-table-column>
                <el-table-column prop="endValue" label="结束值" align="center">
                </el-table-column>
                <el-table-column prop="color" label="颜色" align="center">
                </el-table-column>
              </el-table-column>
            </el-table>
          </div>
        </el-radio>
        <el-radio label="3">
          <span>钠离子</span>
          <div class="tableClass">
            <el-table class="vTable" :data="vTableData3" :cell-style="cellStyle">
              <el-table-column label="电压" align="center">
                <el-table-column prop="startValue" label="起始值" align="center">
                </el-table-column>
                <el-table-column prop="endValue" label="结束值" align="center">
                </el-table-column>
                <el-table-column prop="color" label="颜色" align="center">
                </el-table-column>
              </el-table-column>
            </el-table>
            <el-table class="tTable" :data="tTableData3" :cell-style="cellStyle">
              <el-table-column label="温度" align="center">
                <el-table-column prop="startValue" label="起始值" align="center">
                </el-table-column>
                <el-table-column prop="endValue" label="结束值" align="center">
                </el-table-column>
                <el-table-column prop="color" label="颜色" align="center">
                </el-table-column>
              </el-table-column>
            </el-table>
          </div>
        </el-radio>
      </el-radio-group>
    </template>
    <el-button class="elButton" type="primary" @click="onSave()">保存</el-button>
  </el-card>
</div>
</template>

<script>
import PROJECTAPI from '@/api/project';
export default {
  props: {
    projectName: {
      type: [String, Number]
    },
    projectId: {
      type: [String, Number]
    }
  },
  data() {
    return {
      emsData: [],
      currentSn: '', //当前的sn节点
      radio: '',
      vTableData1: [],
      tTableData1: [],
      vTableData2: [],
      tTableData2: [],
      vTableData3: [],
      tTableData3: [],
      batteryType: 0
    };
  },
  watch: {
    radio(val) {
      this.batteryType = val;
    }
  },
  created() {
    this.searchRuleByProject();
  },
  methods: {
    //查询项目热力图规则列表
    searchRuleByProject() {
      let params = {
        projectId: this.projectId
      };
      PROJECTAPI.searchRuleByProject(params).then(res => {
        let vTableData1 = [];
        let tTableData1 = [];
        let vTableData2 = [];
        let tTableData2 = [];
        let vTableData3 = [];
        let tTableData3 = [];
        if (res.data.code == 200) {
          res.data.data.forEach(ele => {
            if (ele.batteryType == 1 && ele.check) {
              this.radio = '1';
            }
            if (ele.batteryType == 2 && ele.check) {
              this.radio = '2';
            }
            if (ele.batteryType == 3 && ele.check) {
              this.radio = '3';
            }
            for (let i in ele) {
              for (let j in ele[i]) {
                for (let k in ele[i][j].thermodynamicDiagramTemplateList) {
                  if (ele[i][j].thermodynamicDiagramTemplateList[k].batteryType == 1) {
                    if (ele[i][j].thermodynamicDiagramTemplateList[k].type == 1) {
                      vTableData1.push({
                        startValue: ele[i][j].thermodynamicDiagramTemplateList[k].startValue,
                        endValue: ele[i][j].thermodynamicDiagramTemplateList[k].endValue,
                        color: ele[i][j].thermodynamicDiagramTemplateList[k].color,
                        fontColorType: ele[i][j].thermodynamicDiagramTemplateList[k].fontColorType
                      })
                    } else {
                      tTableData1.push({
                        startValue: ele[i][j].thermodynamicDiagramTemplateList[k].startValue,
                        endValue: ele[i][j].thermodynamicDiagramTemplateList[k].endValue,
                        color: ele[i][j].thermodynamicDiagramTemplateList[k].color,
                        fontColorType: ele[i][j].thermodynamicDiagramTemplateList[k].fontColorType
                      })
                    }
                  } else if (ele[i][j].thermodynamicDiagramTemplateList[k].batteryType == 2) {
                    if (ele[i][j].thermodynamicDiagramTemplateList[k].type == 1) {
                      vTableData2.push({
                        startValue: ele[i][j].thermodynamicDiagramTemplateList[k].startValue,
                        endValue: ele[i][j].thermodynamicDiagramTemplateList[k].endValue,
                        color: ele[i][j].thermodynamicDiagramTemplateList[k].color,
                        fontColorType: ele[i][j].thermodynamicDiagramTemplateList[k].fontColorType
                      })
                    } else {
                      tTableData2.push({
                        startValue: ele[i][j].thermodynamicDiagramTemplateList[k].startValue,
                        endValue: ele[i][j].thermodynamicDiagramTemplateList[k].endValue,
                        color: ele[i][j].thermodynamicDiagramTemplateList[k].color,
                        fontColorType: ele[i][j].thermodynamicDiagramTemplateList[k].fontColorType
                      })
                    }
                  } else {
                    if (ele[i][j].thermodynamicDiagramTemplateList[k].type == 1) {
                      vTableData3.push({
                        startValue: ele[i][j].thermodynamicDiagramTemplateList[k].startValue,
                        endValue: ele[i][j].thermodynamicDiagramTemplateList[k].endValue,
                        color: ele[i][j].thermodynamicDiagramTemplateList[k].color,
                        fontColorType: ele[i][j].thermodynamicDiagramTemplateList[k].fontColorType
                      })
                    } else {
                      tTableData3.push({
                        startValue: ele[i][j].thermodynamicDiagramTemplateList[k].startValue,
                        endValue: ele[i][j].thermodynamicDiagramTemplateList[k].endValue,
                        color: ele[i][j].thermodynamicDiagramTemplateList[k].color,
                        fontColorType: ele[i][j].thermodynamicDiagramTemplateList[k].fontColorType
                      })
                    }
                  }
                }
              }
            }
            this.vTableData1 = vTableData1;
            this.tTableData1 = tTableData1;
            this.vTableData2 = vTableData2;
            this.tTableData2 = tTableData2;
            this.vTableData3 = vTableData3;
            this.tTableData3 = tTableData3;
          });
        }
      });
    },
    cellStyle(data) {
      if (data.columnIndex == 2) {
        let fontColor = "";
        if (data.row.fontColorType == 0) { //深色
          fontColor = "#333";
        } else {
          fontColor = "#fff";
        }
        return `background: ${data.row.color};color: ${fontColor}`;
      }
    },
    onSave() {
      let params = {
        batteryType: this.batteryType,
        projectId: this.projectId
      };
      PROJECTAPI.addRule(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('保存成功!');
        }
      })
    }
  }
};
</script>

<style lang="scss">
.projectheatmapconfig {
  .el-card__header {
    font-weight: bold;
    background: #f0f2f5;
    text-align: center;
  }

  .actived {
    background-color: #f0f2f5;
  }

  .el-radio-group {
    width: 100%;
    display: flex;
    flex: 1;
    justify-content: space-around;
  }

  .el-radio {
    margin-right: 0px !important;
  }

  .tableClass {
    margin-top: 10px;
    display: flex;
    flex-direction: row;
  }

  .el-table th,
  .el-table tr {
    padding: 0px !important;
  }

  .el-table td {
    padding: 5px 0px !important;
  }

  .el-table .cell {
    padding: 0px !important;
  }

  .elButton {
    float: right;
    margin: 30px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/project/projectheatmapconfig.vue